import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {
  TeachersVideoSectionComponent
} from '@app/modules/wrtc/components/teachers-video-section/teachers-video-section.component';
import {StudentsSectionComponent} from '@app/modules/wrtc/components/students-sections/students-section.component';
import {RemoteTeacherComponent} from '@app/modules/wrtc/components/remote-teacher/remote-teacher.component';
import {RemoteSupportComponent} from '@app/modules/wrtc/components/remote-support/remote-support.component';
import {RemoteStudentComponent} from '@app/modules/wrtc/components/remote-student/remote-student.component';
import {SharedModule} from '@app/modules/shared/shared.module';
import {NgbDropdownModule, NgbTooltipModule} from '@ng-bootstrap/ng-bootstrap';


@NgModule({
  declarations: [
    RemoteStudentComponent,
    RemoteSupportComponent,
    RemoteTeacherComponent,
    StudentsSectionComponent,
    TeachersVideoSectionComponent,
  ],
  exports: [
    StudentsSectionComponent,
    TeachersVideoSectionComponent
  ],
  imports: [
      CommonModule,
      SharedModule,
      NgbDropdownModule,
      NgbTooltipModule
  ]
})
export class WrtcModule { }
